<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers} from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import { general} from "@/components/common/questionnaires/question/options/general";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";
import {personHelpers} from "@/mixins/personHelpers";
import {textHelpers} from "@/mixins/textHelpers";

export default {
  name: 'RegisterHealthYN',
  mixins: [general, questionLoadHelpers, personHelpers, textHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'Do you want to register this Lasting Power of Attorney?',
        subTitle: 'Lasting Powers of Attorney cannot be used by attorneys until they are registered. It is not uncommon for an LPA to be registered many years after it is signed. This may be following diagnosis of an illness or an accident for example. If you wish to register the document in advance there is a separate fee payable to the Office of the Public Guardian which is currently up to £82 per document. However, the following should be noted:',
        tip: null
      },
      db: {
        saveLocation: 'product_lpa_data',
        saveField: 'registerHealthYN', // fake field name required
        formPath: 'data.details.options.register.health',
        jsonSaveField: 'health'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
